(function performanceEvents(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.FullImageViewer = global.NewHomeSource.FullImageViewer || {};

  if (!global.NewHomeSource.FullImageViewer.Config) {
    return;
  }

  const dataAttributesTdv = global.NewHomeSource.FullImageViewer.Config.dataTdvAttributes;
  const getAttributeValue = global.NewHomeSource.FullImageViewer.Config.getAttributeValue;
  const isBasic = global.document.querySelector('[data-is-basic]').value === 'True';
  const communityVideoEvent = isBasic ? 'CDVID' : 'CDEVCT';
  const dataDetailInfo = {};
  for (let index = 0; index < dataAttributesTdv.length; index += 1) {
    const attribute = dataAttributesTdv[index];
    const value = getAttributeValue(attribute);
    if (value) {
      dataDetailInfo[attribute.replace('data-', '')] = value;
    }
  }

  const previousPerformanceEvents = global.NewHomeSource.FullImageViewer.PerformanceEvents;

  function isHome() {
    return global.document.querySelector('[data-is-community]').value === 'False';
  }

  /**
   * @constructs NewHomeSource.FullImageViewer.PerformanceEvents
   */
  function PerformanceEvents() {
  }

  /**
  * @public
  *
  * PerformanceEvents: logs the video play action.
  */
  PerformanceEvents.logVideo = function logVideo() {
    if (typeof document.body.dispatchEvent === 'function') {
      const data = dataDetailInfo;
      data.label = isHome() ? 'HDEVCT' : communityVideoEvent;
      data.eventType = 'tdvEvent';
      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: {
          data
        }
      }));
    }
  };

  PerformanceEvents.update = function update(data) {
    if (!data.IsFrame) {
      return;
    }

    let label = '';
    switch (data.Type) {
      case 'VWT':
        label = 'HDVTCT';
        break;

      case 'IFP':
        label = 'HDPVCT';
        break;

      default:
    }
    if (label === '') {
      return;
    }

    const eventData = dataDetailInfo;
    eventData.label = label;
    eventData.eventType = 'tdvEvent';
    document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
      detail: {
        data: eventData
      }
    }));
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.FullImageViewer.PerformanceEvents to the previous script.
   */
  PerformanceEvents.noConflict = function noConflict() {
    global.NewHomeSource.FullImageViewer.PerformanceEvents = previousPerformanceEvents;
    return PerformanceEvents;
  };

  global.NewHomeSource.FullImageViewerState.add('onImageSet', PerformanceEvents);
  global.NewHomeSource.FullImageViewer.PerformanceEvents = PerformanceEvents;
}(window));
